// extracted by mini-css-extract-plugin
export var formSection = "styles-module--formSection--KRKb6";
export var info = "styles-module--info--dvzml";
export var textAreaContent = "styles-module--textAreaContent--N14Sl";
export var title = "styles-module--title--dD8Bs";